import React from "react";

export function StatusFormatter(cell) {
  // if (cell === "V") {
  //   return <span className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-red-50 text-red-500">Vencida</span>
  // } else if (cell === "P") {
  //   return <span className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500">Pendente</span>
  // } else {
  //   return <span className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-green-50 text-green-500">Pago</span>
  // };
  return (
    <>
      {
        cell == "A" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500"
          >
            Á Pagar
          </span>
        )
      }
      {
        cell == "V" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-red-50 text-red-500"
          >
            Vencido
          </span>
        )
      }
      {
        cell == "N" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500"
          >
            Pendente Aprovação
          </span>
        )
      }
      {
        cell == "E" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500"
          >
            Pendente Geração
          </span>
        )
      }
      {
        cell == "C" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-red-50 text-red-500"
          >
            Cancelado
          </span>
        )
      }
      {
        cell == "R" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500"
          >
            Alterado Data Vencimento/Valor Total do Boleto a Gerar
          </span>
        )
      }
      {
        cell == "L" && (
          <span
            className="px-[10px] py-[6px] text-xs font-semibold rounded-xl bg-yellow-50 text-yellow-500"
          >
            Negociado
          </span>
        )
      }
      {cell == "O" && (
        <span
          className="px-[10px] py-[6px] text-xs font-semibold bg-yellow-50 rounded-3xl text-yellow-500"
        >
          Cobranças Agrupadas/Pendente Aprovação
        </span>
      )}

      {cell == "G" && (
        <span
          className="px-[10px] py-[6px] text-xs font-semibold bg-yellow-50 rounded-3xl text-yellow-500"
        >
          A ser gerado
        </span>
      )}
      {cell == "P" && (
        <span
          className="px-[10px] py-[6px] text-xs font-semibold bg-green-50 rounded-3xl text-green-500"
        >
          Liquidado
        </span>
      )}
      {cell == "U" && (
        <span
          className="px-[10px] py-[6px] text-xs font-semibold bg-green-50 rounded-3xl text-green-500"
        >
          Boleto Unificado
        </span>
      )}
    </>)
};